import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class RegulationTagsApi extends ApiModule {
	constructor() {
		super(ModulesMap.REGULATION_TAGS, {
			entity: 'regulations_tags',
		})
	}
}
